var map = {
	"./1-no-filter.png": "f9Nr",
	"./2-polaroid.png": "6Cv6",
	"./3-grayscale.png": "YdZt",
	"./4-sepia.png": "bOkG",
	"./5-vintage.png": "Kw7n",
	"./6-kodachrome.png": "xda4",
	"./7-technicolor.png": "xxgD",
	"./empty_product.png": "N3bD",
	"./logo.png": "h12e"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eRda";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets ^\.\/.*$
// module id = eRda
// module chunks = 1